<template>
  <div class="inform-page pk-account-panel">
    <section class="inform-hero">
      <div class="hero-copy">
        <span>消息通知</span>
        <h1>消息通知</h1>
        <p>
          系统公告、站内提示和饰品取回历史统一展示。取回申请会进入人工审核，处理进度将在记录中更新。
        </p>
        <div class="hero-actions">
          <button @click="activeTab = 'records'">查看取回记录</button>
          <button class="ghost" @click="goPath('/Dota')">进入库存</button>
        </div>
      </div>
      <div class="hero-device">
        <span class="orbit"></span>
        <img src="/img/pizzaking/columns/notices.png" alt="" />
        <strong>{{ totalSize }}</strong>
        <em>条取回历史</em>
      </div>
    </section>

    <section class="status-grid">
      <article>
        <span>系统公告</span>
        <strong>{{ noticeList.length }}</strong>
        <em>站内公告 + 运营提示</em>
      </article>
      <article>
        <span>个人通知</span>
        <strong>{{ unreadCount }}</strong>
        <em>未读 / 共 {{ personalTotal }} 条</em>
      </article>
      <article>
        <span>发货状态</span>
        <strong>人工审核</strong>
        <em>人工审核处理中</em>
      </article>
      <article>
        <span>取回记录</span>
        <strong>{{ totalSize }}</strong>
        <em>站内公告</em>
      </article>
    </section>

    <section class="inform-board">
      <div class="tab-bar">
        <div>
          <button :class="{ active: activeTab == 'notice' }" @click="activeTab = 'notice'">
            系统通知
          </button>
          <button :class="{ active: activeTab == 'records' }" @click="activeTab = 'records'">
            取回记录
          </button>
        </div>
        <button
          v-if="activeTab == 'notice' && loggedIn && unreadCount > 0"
          class="mark-all"
          @click="markNoticeRead('all')"
        >
          全部已读
        </button>
      </div>

      <div v-if="activeTab == 'notice'" class="notice-list">
        <article v-for="item in noticeList" :key="noticeKey(item)" class="notice-card" :class="{ unread: item.is_read === 0 }">
          <div class="notice-icon" :class="item.type">
            <i></i>
          </div>
          <div>
            <strong>{{ item.title }} <em v-if="item.is_read === 0">未读</em></strong>
            <p>{{ item.content }}</p>
            <span>{{ item.created_at }}</span>
            <button v-if="item.is_read === 0" class="mark-one" @click="markNoticeRead(item.id)">标记已读</button>
          </div>
        </article>
        <div v-if="!noticeList.length" class="empty-card">暂无系统公告或个人通知。</div>
      </div>

      <div v-else class="record-panel">
        <div class="delivery-note">
          <div>
            <strong>取回功能说明</strong>
            <p>取回申请会进入人工审核，处理进度将在取回记录中更新。</p>
          </div>
          <button @click="loggedIn ? goPath('/Dota') : openLogin()">查看库存</button>
        </div>

        <div v-if="!loggedIn" class="inform-auth-card">
          <img src="/img/pizzaking/columns/notices.png" alt="" />
          <div>
            <span>需要登录</span>
            <strong>登录后查看取回记录</strong>
            <p>饰品取回记录绑定当前账号。登录后可查看人工审核进度和记录状态。</p>
          </div>
          <button @click="openLogin">登录账号</button>
        </div>

        <template v-else>
          <div v-if="tableData.length" class="record-list">
            <article v-for="item in tableData" :key="item.plat_order || item.name" class="record-card">
              <div class="skin-img">
                <img :src="recordImage(item)" alt="" />
              </div>
              <div class="record-main">
                <div class="record-title">
                  <strong>{{ item.name }}</strong>
                  <span :class="statusClass(item)">{{ statusText(item) }}</span>
                </div>
                <div class="record-meta">
                  <span>订单号：{{ item.display_order_no || item.plat_order || item.order_num || '-' }}</span>
                  <span>处理编号：{{ item.display_order_id || item.orderId || '-' }}</span>
                  <span>用户：{{ maskMobile(item.mobile) }}</span>
                  <span>申请时间：{{ item.order_time || '-' }}</span>
                  <span>完成时间：{{ item.receive_time || '-' }}</span>
                  <span>取回进度：{{ item.state_name || statusText(item) }}</span>
                </div>
                <p v-if="item.delivery_review_remark" class="return-reason">
                  退回理由：{{ item.delivery_review_remark }}
                </p>
              </div>
              <div class="record-price">
                <div><strong>{{ priceText(item.price) }}</strong><i></i></div>
              </div>
            </article>
          </div>

          <div v-else class="empty-card">
            暂无取回记录。提交饰品人工取回申请后，审核进度会在这里展示。
          </div>

          <el-pagination
            v-if="totalSize > pageSize"
            class="record-page"
            background
            layout="prev, pager, next"
            :page-size="pageSize"
            :total="totalSize"
            @current-change="currentChange"
          ></el-pagination>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ["yidongmenu", "showNav", "openHongbao"],
  data() {
    return {
      activeTab: "notice",
      notices: [],
      personalNotices: [],
      personalTotal: 0,
      unreadCount: 0,
      tableData: [],
      totalSize: 0,
      page: 1,
      pageSize: 8,
      fallbackSkin: "/img/pizzaking/columns/notices.png",
    };
  },
  computed: {
    loggedIn() {
      return Boolean(this.$store.state.token || localStorage.getItem("token"));
    },
    noticeList() {
      return this.personalNotices.concat(this.notices);
    },
  },
  mounted() {
    this.getNotices();
    if (this.loggedIn) {
      this.getPersonalNotices();
      this.getskinToSteam(this.page);
    }
  },
  watch: {
    loggedIn(value) {
      if (value) {
        this.getPersonalNotices();
        this.getskinToSteam(this.page);
      }
    },
  },
  methods: {
    getNotices() {
      this.$axios.post("/index/System/notices", this.$qs.stringify({})).then((res) => {
        if (res.data.status == 1) {
          this.notices = res.data.data.list;
        }
      });
    },
    getPersonalNotices() {
      this.$axios
        .post(
          "/index/System/playerNotices",
          this.$qs.stringify({
            page: 1,
            pageSize: 20,
          })
        )
        .then((res) => {
          if (res.data.status == 1) {
            this.personalNotices = res.data.data.list;
            this.personalTotal = res.data.data.total;
            this.unreadCount = res.data.data.unread;
          }
        });
    },
    markNoticeRead(id) {
      this.$axios
        .post(
          "/index/System/readPlayerNotice",
          this.$qs.stringify({
            id,
          })
        )
        .then((res) => {
          if (res.data.status == 1) {
            this.getPersonalNotices();
            this.$emit("notice-read");
            this.$root.$emit("notice-read");
          } else {
            this.$message.warning(res.data.msg || "操作失败");
          }
        });
    },
    getskinToSteam(page) {
      if (!localStorage.getItem("token")) {
        return;
      }
      this.$axios
        .post(
          "/index/Lucky/getskinToSteam",
          this.$qs.stringify({
            page,
            pageSize: this.pageSize,
          })
        )
        .then((res) => {
          if (res.data.status == 1) {
            this.totalSize = res.data.data.total;
            this.tableData = res.data.data.list;
          } else {
            this.totalSize = 0;
            this.tableData = [];
          }
        });
    },
    currentChange(val) {
      this.page = val;
      this.getskinToSteam(val);
    },
    recordImage(item) {
      return item.img || this.fallbackSkin;
    },
    priceText(price) {
      return Number(price || 0).toFixed(2);
    },
    maskMobile(mobile) {
      return mobile ? mobile.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2") : "-";
    },
    statusText(item) {
      if (item.state == "failed") {
        return "已退回";
      }
      if (item.status_name) {
        return item.status_name;
      }
      if (item.state_name) {
        return item.state_name;
      }
      if (item.status == 4) {
        return "已完成";
      }
      return item.status == 5 ? "处理中" : "取回中";
    },
    statusClass(item) {
      return {
        "status-badge": true,
        success: item.state == "success" || item.status_name == "已完成",
        failed: item.state == "failed",
      };
    },
    noticeKey(item) {
      return (item.type || "system") + "-" + item.id;
    },
    goPath(path) {
      this.$router.push(path);
    },
    openLogin() {
      this.$store.commit("getLogin", true);
    },
  },
};
</script>

<style lang="less" scoped>
.inform-page {
  min-height: calc(100vh - 198px);
  padding: 26px 26px 74px;
  color: #f4f7ff;
  background:
    radial-gradient(circle at 48% 4%, rgba(255, 138, 31, 0.15), transparent 34%),
    radial-gradient(circle at 86% 30%, rgba(0, 217, 255, 0.1), transparent 28%),
    linear-gradient(180deg, #1d202c 0%, #171923 100%);
}

button {
  font-family: inherit;
}

.inform-hero,
.status-grid,
.inform-board {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.inform-hero {
  min-height: 292px;
  padding: 40px 52px;
  display: grid;
  grid-template-columns: 1.25fr 0.75fr;
  gap: 28px;
  align-items: center;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 132, 31, 0.32);
  border-radius: 22px;
  background:
    linear-gradient(135deg, rgba(39, 42, 58, 0.96), rgba(24, 26, 36, 0.98)),
    url("../assets/new/task_bg.png") center / cover;
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.36);
}

.inform-hero::after {
  content: "";
  width: 560px;
  height: 560px;
  position: absolute;
  right: -170px;
  top: -170px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 147, 31, 0.32), transparent 66%);
}

.hero-copy {
  position: relative;
  z-index: 1;
}

.hero-copy span {
  color: #ff8a1f;
  font-size: 13px;
  font-weight: 900;
  letter-spacing: 0.16em;
}

.hero-copy h1 {
  margin: 12px 0 16px;
  font-size: 56px;
  line-height: 1;
  font-weight: 1000;
}

.hero-copy p {
  max-width: 650px;
  color: #aeb6c8;
  font-size: 17px;
  line-height: 1.8;
}

.hero-actions {
  margin-top: 24px;
  display: flex;
  gap: 12px;
}

.hero-actions button,
.delivery-note button {
  height: 46px;
  padding: 0 24px;
  color: #151620;
  background: linear-gradient(180deg, #ffcb28, #ff8a00);
  border: 0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 1000;
  cursor: pointer;
  box-shadow: 0 12px 28px rgba(241, 107, 0, 0.28);
}

.hero-actions .ghost {
  color: #f4f7ff;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: none;
}

.hero-device {
  width: 250px;
  height: 250px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background:
    radial-gradient(circle, rgba(255, 209, 112, 0.26), rgba(255, 112, 24, 0.08) 58%, transparent 60%),
    #222636;
  box-shadow: inset 0 0 42px rgba(255, 150, 31, 0.16), 0 32px 70px rgba(0, 0, 0, 0.36);
}

.hero-device .orbit {
  width: 286px;
  height: 122px;
  position: absolute;
  border-bottom: 1px solid rgba(255, 216, 142, 0.38);
  border-radius: 50%;
}

.hero-device img {
  width: 112px;
  filter: drop-shadow(0 18px 26px rgba(255, 147, 31, 0.28));
}

.hero-device strong {
  margin-top: 8px;
  color: #ffd764;
  font-size: 42px;
  line-height: 1;
  font-weight: 1000;
}

.hero-device em {
  margin-top: 6px;
  color: #aab3c6;
  font-style: normal;
  font-weight: 800;
}

.status-grid {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}

.status-grid article,
.inform-board,
.notice-card,
.delivery-note,
.record-card,
.empty-card,
.inform-auth-card {
  background: linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.035);
}

.status-grid article {
  min-height: 110px;
  padding: 20px 22px;
  position: relative;
  overflow: hidden;
}

.status-grid article::after {
  content: "";
  width: 160px;
  height: 160px;
  position: absolute;
  right: -80px;
  top: -80px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 138, 31, 0.22), transparent 68%);
}

.status-grid span {
  display: block;
  color: #9aa3b8;
  font-size: 13px;
  font-weight: 900;
}

.status-grid strong {
  display: block;
  margin-top: 12px;
  color: #f8fbff;
  font-size: 28px;
  font-weight: 1000;
}

.status-grid em {
  display: block;
  margin-top: 8px;
  color: #70798e;
  font-size: 13px;
  font-style: normal;
}

.inform-board {
  margin-top: 18px;
  padding: 22px;
}

.tab-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tab-bar > div {
  display: inline-flex;
  padding: 5px;
  gap: 5px;
  background: #1c1e28;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 10px;
}

.tab-bar button {
  height: 40px;
  padding: 0 22px;
  color: #9aa3b8;
  background: transparent;
  border: 0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 1000;
  cursor: pointer;
}

.tab-bar button.active {
  color: #151620;
  background: linear-gradient(180deg, #ffcb28, #ff8a00);
}

.tab-bar .mark-all {
  color: #ffe6c5;
  background: rgba(255, 138, 31, 0.12);
  border: 1px solid rgba(255, 138, 31, 0.32);
}

.notice-list {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.notice-card {
  min-height: 132px;
  padding: 20px;
  display: grid;
  grid-template-columns: 54px 1fr;
  gap: 16px;
  align-items: flex-start;
}

.notice-card.unread {
  border-color: rgba(255, 138, 31, 0.36);
  box-shadow:
    0 18px 50px rgba(0, 0, 0, 0.22),
    inset 3px 0 0 rgba(255, 138, 31, 0.86);
}

.notice-icon {
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: radial-gradient(circle, rgba(255, 138, 31, 0.28), rgba(255, 138, 31, 0.08));
  box-shadow: inset 0 0 20px rgba(255, 164, 48, 0.18);
}

.notice-icon i,
.record-price i {
  width: 18px;
  height: 18px;
  display: block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.notice-card strong {
  color: #f4f7ff;
  font-size: 17px;
  font-weight: 1000;
}

.notice-card strong em {
  margin-left: 8px;
  padding: 3px 7px;
  color: #151620;
  background: linear-gradient(180deg, #ffcb28, #ff8a00);
  border-radius: 999px;
  font-size: 11px;
  font-style: normal;
}

.notice-card p {
  margin: 9px 0 12px;
  color: #aab3c6;
  font-size: 14px;
  line-height: 1.65;
}

.notice-card span {
  color: #ff9d24;
  font-size: 12px;
  font-weight: 1000;
  letter-spacing: 0.06em;
}

.mark-one {
  height: 30px;
  margin-top: 12px;
  padding: 0 12px;
  color: #ffe6c5;
  background: rgba(255, 138, 31, 0.12);
  border: 1px solid rgba(255, 138, 31, 0.32);
  border-radius: 6px;
  font-size: 12px;
  font-weight: 900;
  cursor: pointer;
}

.record-panel {
  margin-top: 18px;
}

.delivery-note {
  padding: 18px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.delivery-note strong {
  color: #f4f7ff;
  font-size: 18px;
  font-weight: 1000;
}

.delivery-note p {
  margin-top: 7px;
  color: #aab3c6;
  font-size: 14px;
}

.record-list {
  margin-top: 14px;
  display: grid;
  gap: 10px;
}

.record-card {
  min-height: 118px;
  padding: 14px 18px 14px 14px;
  display: grid;
  grid-template-columns: 96px 1fr 110px;
  gap: 18px;
  align-items: center;
}

.skin-img {
  width: 96px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background:
    radial-gradient(circle at 50% 46%, rgba(255, 110, 31, 0.18), transparent 58%),
    #252836;
}

.skin-img img {
  max-width: 88px;
  max-height: 74px;
  object-fit: contain;
  filter: drop-shadow(0 12px 18px rgba(0, 0, 0, 0.35));
}

.record-title {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.record-title strong {
  color: #f4f7ff;
  font-size: 17px;
  font-weight: 1000;
}

.status-badge {
  padding: 5px 9px;
  color: #aeb7ca;
  background: rgba(255, 255, 255, 0.055);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 1000;
}

.status-badge.success {
  color: #95ffd1;
  background: rgba(24, 203, 132, 0.13);
}

.status-badge.failed {
  color: #ff9a9a;
  background: rgba(255, 84, 84, 0.13);
}

.record-meta {
  margin-top: 13px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 16px;
  color: #8f98ad;
  font-size: 13px;
}

.return-reason {
  margin: 12px 0 0;
  padding: 9px 12px;
  color: #ffc1a8;
  background: rgba(255, 106, 48, 0.09);
  border-left: 3px solid #ff6a30;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.6;
}

.record-price {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 7px;
}

.record-price > div {
  display: flex;
  align-items: center;
  gap: 7px;
}

.record-price strong {
  color: #ffd764;
  font-size: 22px;
  font-weight: 1000;
}

.empty-card {
  margin-top: 14px;
  padding: 36px 18px;
  color: #929bad;
  text-align: center;
  font-size: 14px;
  font-weight: 800;
}

.inform-auth-card {
  min-height: 230px;
  margin-top: 14px;
  padding: 28px;
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr) auto;
  gap: 24px;
  align-items: center;
  background:
    radial-gradient(circle at 12% 50%, rgba(255, 138, 31, 0.24), transparent 34%),
    linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98));
  border-color: rgba(255, 132, 31, 0.24);
}

.inform-auth-card img {
  width: 170px;
  max-height: 150px;
  object-fit: contain;
  filter: drop-shadow(0 20px 28px rgba(255, 138, 31, 0.22));
}

.inform-auth-card span {
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
}

.inform-auth-card strong {
  display: block;
  margin-top: 8px;
  color: #fbfcff;
  font-size: 30px;
  font-weight: 1000;
}

.inform-auth-card p {
  max-width: 620px;
  margin: 10px 0 0;
  color: #aeb7c8;
  font-size: 15px;
  line-height: 1.7;
  font-weight: 800;
}

.inform-auth-card button {
  height: 44px;
  padding: 0 24px;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
  border-radius: 8px;
  font-weight: 1000;
  cursor: pointer;
  box-shadow: 0 14px 34px rgba(255, 131, 0, 0.24);
}

.record-page {
  margin-top: 18px;
  text-align: right;
}

.record-page /deep/ .el-pager li:not(.disabled).active {
  color: #151620;
  background: #ffae1d;
}

.record-page /deep/ .el-pagination.is-background .btn-next,
.record-page /deep/ .el-pagination.is-background .btn-prev,
.record-page /deep/ .el-pagination.is-background .el-pager li {
  color: #aab3c6;
  background: #242735;
}

@media screen and (max-width: 980px) {
  .inform-page {
    padding: 18px 12px 58px;
  }

  .inform-hero,
  .status-grid,
  .notice-list,
  .inform-auth-card,
  .record-card {
    grid-template-columns: 1fr;
  }

  .inform-hero {
    padding: 28px 22px;
  }

  .hero-copy h1 {
    font-size: 42px;
  }

  .hero-device {
    width: 220px;
    height: 220px;
  }

  .delivery-note {
    display: block;
  }

  .delivery-note button {
    margin-top: 14px;
  }

  .record-meta {
    grid-template-columns: 1fr;
  }

  .record-price {
    justify-content: flex-start;
  }
}
</style>

<style lang="less">
.inform-page.pk-account-panel {
  padding: 32px 28px 96px !important;
}

.inform-page.pk-account-panel .inform-hero,
.inform-page.pk-account-panel .status-grid,
.inform-page.pk-account-panel .inform-board {
  width: calc(100% - 24px) !important;
  max-width: 1540px !important;
}

.inform-page.pk-account-panel .inform-hero {
  min-height: 318px !important;
  border-color: rgba(255, 132, 31, 0.38) !important;
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.38),
    inset 0 1px 0 rgba(255, 224, 170, 0.08) !important;
}

.inform-page.pk-account-panel .hero-device img {
  width: 230px !important;
  filter:
    drop-shadow(0 28px 34px rgba(0, 0, 0, 0.46))
    drop-shadow(0 0 22px rgba(255, 138, 0, 0.24)) !important;
}

.inform-page.pk-account-panel .status-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  gap: 16px !important;
}

.inform-page.pk-account-panel .inform-board {
  padding: 24px !important;
  border-color: rgba(111, 121, 151, 0.22) !important;
}

.inform-page.pk-account-panel .record-card,
.inform-page.pk-account-panel .notice-card,
.inform-page.pk-account-panel .inform-auth-card {
  border-color: rgba(111, 121, 151, 0.22) !important;
}

.inform-page.pk-account-panel .skin-img {
  width: 116px !important;
  height: 96px !important;
}

.inform-page.pk-account-panel .skin-img img {
  max-width: 108px !important;
  max-height: 84px !important;
}

@media screen and (max-width: 980px) {
  .inform-page.pk-account-panel {
    padding: 18px 12px 58px !important;
  }

  .inform-page.pk-account-panel .inform-hero,
  .inform-page.pk-account-panel .status-grid,
  .inform-page.pk-account-panel .inform-board {
    width: 100% !important;
  }

  .inform-page.pk-account-panel .status-grid {
    grid-template-columns: 1fr !important;
  }
}

/* 2026-07-05 exact internal pass: notices and delivery records. */
.inform-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  padding: 24px 24px 96px !important;
  background:
    radial-gradient(ellipse at 50% 170px, rgba(255, 138, 31, 0.08), transparent 420px),
    linear-gradient(180deg, #20222f 0, #1c1d29 420px, #171923 100%) !important;
}

.inform-page.pk-account-panel .inform-hero,
.inform-page.pk-account-panel .status-grid,
.inform-page.pk-account-panel .inform-board {
  width: 100% !important;
  max-width: none !important;
}

.inform-page.pk-account-panel .inform-hero {
  min-height: 270px !important;
  padding: 30px 38px !important;
  border: 1px solid #2b2d3c !important;
  border-radius: 8px !important;
  background:
    radial-gradient(ellipse at 74% 52%, rgba(255, 138, 31, 0.14), transparent 48%),
    #20222f !important;
  box-shadow: none !important;
}

.inform-page.pk-account-panel .hero-copy h1 {
  color: #f4ead8 !important;
}

.inform-page.pk-account-panel .status-grid article,
.inform-page.pk-account-panel .inform-board,
.inform-page.pk-account-panel .record-card,
.inform-page.pk-account-panel .notice-card,
.inform-page.pk-account-panel .inform-auth-card {
  border-color: #2b2d3c !important;
  background: #20222f !important;
}

.inform-page.pk-account-panel .record-card,
.inform-page.pk-account-panel .notice-card {
  border-radius: 8px !important;
}
</style>
